export const InosioImplementationCallUrl = 'https://calendly.com/d/cmnj-psz-3xb/inosio-implementation-meeting';
export const UNREG_DEBIT_CARD_GENERIC =
  'Debit cards have variable processing costs. Enter your card details to see the specific fee amount. Certain banks qualify for discounts; if your card is issued by one of those banks we will pass that discount on to you. More info: http://support.inosio.com/article/debit-card-processing';
export const UNREG_DEBIT_CARD_SPECIFIC =
  'Debit cards have variable processing costs. This debit card does not qualify for the discounted debit card pricing option. More info: http://support.inosio.com/article/debit-card-processing';
// eslint-disable-next-line
export const PASSWORD_REQUIREMENTS = `Password must be a minimum of 8 characters and at least one uppercase, one lowercase, one number, and one special character:  - '/\`~!#*$@_%+=.,^&(){}[]|;:”<>?.`;
export const ONE_MEGABYTE_SIZE = 1048576;
export const PAYSAFE_2025_SAQ_A_ACK_UUID = 'fec9d5fd-cc8e-11ef-a6e2-0641fa68d545';
export const IPA_ACCESS_TOKEN_NAME = 'ipaAccessToken';
export const IPA_MFA_TOKEN_NAME = 'ipaMfaToken';
export const HEALTHCHECK_POLL_INTERVAL = 60_000;
export const MIME_TYPES_VIEWABLE_IN_BROWSER = [
  'image/png',
  'image/jpeg',
  'application/pdf',
];
export const TENANTREPORTS_BASE_URL = 'https://www.tenantreportx.com';